import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-upload-failure-modal.css';

const RbUploadFailureModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={'Upload fail'}
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <h3 className={styles.title}>{'Sorry!'}</h3>
                    <p className={styles.text}>
                        {'Update failed. Please check the port number and choose the correct device type.'}
                    </p>
                </Box>
                <Box className={styles.buttonRow}>
                    <button
                        className={styles.okButton}
                        onClick={props.onCancel}
                    >
                        {'OK'}
                    </button>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbUploadFailureModal.propTypes = {
    onCancel: PropTypes.func.isRequired
};

export default RbUploadFailureModal;
